import { useEffect, useRef, useState } from 'react';
import "../../Assets/scss/components/copy-widget-script-code.scss";
import { Button, Card, Form, InputGroup, Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { StoreProptypes } from '../../PropTypes/StoreProptypes';
import { useDispatch } from 'react-redux';
import { SET_CURRENT_WEBSITE, SET_MESSAGE, UPDATE_USER } from '../../Actions/Types';
import getEUCountryList from '../../Helpers/EUCountryList';
import { updateUserService } from '../../Services/UserAction/UpdateUserDetails';
import { postUserActivityListService } from '../../Services/UserActivityService';
import encodeBase64 from '../../Helpers/encodeBase64';
import { VerifyDomainService } from '../../Services/DomainService/VerifyDomain';
import { UpdateEUFlagDomainService } from '../../Services/DomainService/UpdateEUFlagDomain';

interface PropsTypes {
    widgetAPIKey: string | null, //widget API Key
    widgetPosition: string | null, // widget position
    widgetColor: string | null // widget color
    isShow?: number // widget color
    isMigratedFlag?:boolean
    isFromDashboard?:boolean
    isFirstTimeLoad?:boolean
    revertBackToOriginalLanguage?:Function
}

const ReactAppAPIKeyChanges = `${process.env.REACT_APP_API_KEY_CHANGES}`;

const EUServerMigrationPopup = (props: PropsTypes) => {
 
    // get Props
    const { widgetAPIKey, widgetPosition, widgetColor, isShow, isMigratedFlag, isFromDashboard, revertBackToOriginalLanguage, isFirstTimeLoad } = props;

    const [codeToggle, setCodeToggle] = useState<boolean>(true);  //this was false for unchecked. made true for default check
    const [widgetCode, setWidgetCode] = useState('');
    const [copyCodeSuccess, setCopyCodeSuccess] = useState<boolean>(false);
    const accessToken = useSelector((store: StoreProptypes) => store.accessToken);
    const website = useSelector((store: StoreProptypes) => store.currentWebsite);
    const user = useSelector((store: StoreProptypes) => store.user);
    const [isEUScriptShow, setIsEUScriptShow] = useState(isShow === 1 ? true : false);
    const [advanceCodeInfoModel, setAdvanceCodeInfoModel] = useState<boolean>(false);
    const getEUCoutryLists = getEUCountryList()
    const [isVerified, setIsVerified] = useState(false);
    const intervalRef = useRef<any>(null);
    const [message, setMessage] = useState("");
    const [count, setCount] = useState(0);
    const [loading, setLoading] = useState(false);
    const [isMigrated, setIsMigrated] = useState<boolean>(isMigratedFlag ?? false)
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [isEUScriptSwitch, setIsEUScriptSwitch] = useState<boolean>(false);
    console.log('isEUScriptSwitch: ', isEUScriptSwitch);
    const [isShowVerifyDomain, setIsShowVerifyDomain] = useState<boolean>(false);

    // function to display advanced code Model
    const handleShowWidgetAdvanceCodeInfoModel = () => setAdvanceCodeInfoModel(true);

    // function to hide advanced code Model
    const handleHideWidgetAdvanceCodeInfoModel = () => setAdvanceCodeInfoModel(false);

    

    useEffect(() => {
    
            let widgetColorFinal: string;
    
            // check if widget color exists
            if (widgetColor) {
                // check if widget color includes #
                if (widgetColor.indexOf('#')) {
                    widgetColorFinal = `#${widgetColor}`;
                } else {
                    widgetColorFinal = widgetColor;
                }
            }
            else {
                widgetColorFinal = '#420083';
            }
    
            // check if wants to display script code for react app
            if (ReactAppAPIKeyChanges === 'true') {
                setWidgetCode(`<script>setTimeout(() => { let aioa_script_tag = document.createElement("script"); aioa_script_tag.src = "${(website && website.no_required_eu === 0) || isMigratedFlag || isFromDashboard || isFirstTimeLoad ? "https://stagingeu.skynettechnologies.com" : "https://www.skynettechnologies.com"}/accessibility/js/all-in-one-accessibility-js-widget-minify.js?colorcode=${widgetColorFinal}&position=${widgetPosition ? widgetPosition : 'bottom_right'}"; aioa_script_tag.defer="true"; aioa_script_tag.id = "aioa-adawidget"; document.getElementsByTagName("body")[0].appendChild(aioa_script_tag); }, 3000);</script>`);
            } else {
                // check if advanced code is toggled
                if (codeToggle) {
                    setWidgetCode(`<script>setTimeout(() => { let aioa_script_tag = document.createElement("script"); aioa_script_tag.src = "${(website && website.no_required_eu === 0) || isMigratedFlag || isFromDashboard || isFirstTimeLoad ? "https://stagingeu.skynettechnologies.com" : "https://www.skynettechnologies.com"}/accessibility/js/all-in-one-accessibility-js-widget-minify.js?colorcode=${widgetColorFinal}&token=${widgetAPIKey}&position=${widgetPosition ? widgetPosition : 'bottom_right'}";  aioa_script_tag.id = "aioa-adawidget";aioa_script_tag.defer="true"; document.getElementsByTagName("body")[0].appendChild(aioa_script_tag); }, 3000);</script>`);
                } else {
                    setWidgetCode(`<script id="aioa-adawidget" src="${(website && website.no_required_eu === 0) || isMigratedFlag || isFromDashboard || isFirstTimeLoad ? "https://stagingeu.skynettechnologies.com" : "https://www.skynettechnologies.com"}/accessibility/js/all-in-one-accessibility-js-widget-minify.js?colorcode=${widgetColorFinal}&token=${widgetAPIKey}&position=${widgetPosition ? widgetPosition : 'bottom_right'}" defer></script>`);
                }
            }
    }, [codeToggle, widgetAPIKey, widgetPosition, widgetColor])

    useEffect(() => {
        if (website?.no_required_eu === 0) {
            setIsEUScriptSwitch(true)
        } else {
            setIsEUScriptSwitch(false)
        }
    },[website])

    const handleHideScriptCodeModel = (flag:boolean) => {
            if (accessToken && website && website.id) {
                let is_eu_script_show = 1;
                let is_eu_script_show_first = 0;
                if (isFirstTimeLoad && flag) {
                    is_eu_script_show = 0;
                    is_eu_script_show_first = 0;
                } else  {
                    if (isFromDashboard && flag) {
                        is_eu_script_show = 0;
                    } else {
                        is_eu_script_show_first = 0;
                    }
                }
                UpdateEUFlagDomainService(accessToken, dispatch, website.id, is_eu_script_show, is_eu_script_show_first, flag ? 0 : 1).then((d) => {
                    if (d.status === 200) {
                        if (flag === true && accessToken) {
                            postUserActivityListService(accessToken, 'Migrate to EU', 'User requested to migrate EU')
                        }
                        dispatch({
                            type: SET_CURRENT_WEBSITE,
                            payload: {...website,  ...(isFirstTimeLoad && flag === true ?
                                {
                                    is_eu_script_show: 0,
                                    is_eu_script_show_first : 0
                                }
                                : 
                                isFromDashboard && flag === true
                                ? { is_eu_script_show: 0 }
                                : { is_eu_script_show_first : 0}),
                                no_required_eu: flag ? 0 : 1}
                        });
                    }
                })
            }
    }

    const handleWidgetCopyCode = () => {
        navigator.clipboard.writeText(widgetCode);
        setCopyCodeSuccess(true);

        // dispatch copy success message
        dispatch({
            type: SET_MESSAGE,
            payload: {
                "toast_message": t('Copied'),
                "toast_type": "success"
            }
        });

        setTimeout(() => {
            setCopyCodeSuccess(false);
        }, 5000)
    }

    const handleMigration = (flag:boolean) => {
        if (flag) {
            handleHideScriptCodeModel(true)
            setIsMigrated(true)
            if(isFromDashboard) {
                setIsEUScriptShow(true)
                setIsShowVerifyDomain(true)
            }
        } else {
            handleHideScriptCodeModel(false)
            setIsEUScriptShow(false)
        }
    }

    const handleClosePopup = () => {
        setIsEUScriptShow(false)
        setIsEUScriptSwitch(false)
    }

    const updateMigrationFlag = () => {
        setIsEUScriptShow(true)
        if (isEUScriptSwitch) {
            setIsMigrated(false)
        } else {
            setIsMigrated(true)
            setIsEUScriptSwitch(true)
        }
    }

    const updateStoreForEUPopUp = () => {
        const updatedWebsite = website
        if (updatedWebsite) {
            updatedWebsite.is_eu_script_show_first = 0
            dispatch({
                type: SET_CURRENT_WEBSITE,
                payload: updatedWebsite
            });
        }
        setIsEUScriptShow(false)
    }

    const verifyDomain = async () => {
        setCount(1);
        setLoading(true);
        intervalRef.current = setInterval(() => setCount((prev) => prev + 1), 1000);
        console.log("iframe load");

        try {
            if (accessToken && website) {
                const response = await VerifyDomainService(accessToken, encodeBase64(website?.id.toString()), dispatch, setMessage, setIsVerified)
    
                clearInterval(intervalRef.current);
                setCount(45);
            }
        } catch (error) {
            console.error("Verification error:", error);
            setMessage("Verification failed. Please try again.");
        } finally {
            setLoading(false);
        }
    }; 

    return (
        <>
            {isFromDashboard && website?.is_eu_script_show ? (
                <div className='d-flex gap-2 justify-content-end my-2'>
                    <div className='fs-5'>Migrate server to</div>
                    {isEUScriptSwitch && (
                        <span
                            role="button"
                            className='fs-5'
                            onClick={() => updateMigrationFlag()}
                        >
                        {t("non-EU")}
                        </span>
                    )}
                    {!isEUScriptSwitch && (
                        <span
                            role="button"
                            className='fs-5'
                            onClick={() => updateMigrationFlag()}
                        >
                        {t("EU")}
                        </span>
                    )}
                    <Form.Check // prettier-ignore
                        type="switch"
                        key={website.id}
                        id="custom-switch"
                        aria-label="Toggle Annual Plan"
                        checked={isEUScriptSwitch}          // convert to boolean for safety
                        onChange={() =>
                            updateMigrationFlag()
                        }
                    />
                </div>
            ) : <></>} 
            <Modal show={isEUScriptShow} {...(isMigrated && { onHide: () => handleClosePopup() })} size='lg' backdrop="static" centered>
                <Modal.Header {...(isMigrated ? { closeButton: true } : {})}>
                <Modal.Title>{t('EU Migration - Need Consent!')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {!isMigrated ? 
                        <div>
                            <div className='mt-2'>
                                <b>{t(`We are migrating data on the EU Server to Improve Compliance and performance`)}.</b>
                            </div>
                            <div className='fs-5 mt-4'>
                                <b>{t(`Would you like to proceed with the migration now`)}? &nbsp;</b>
                            </div>
                        </div>
                    :
                    <>
                        <b>{t("Website URL")} :</b> {website?.domain}
                        <Card className="aioa_dashboard-copy-widget-code mt-3">
                            <Card.Body>
                            <b>{t('We are glade to inform you, As per GDPR Compliance we have migrated your data to EU server, so please update your integration script')}</b>
                                <div className='aioa_dashboard-widget-code mt-3'>
                                    <div className='aioa_dashboard-widget-code-copy-btn'>
                                        <Button aria-label={t("Copy widget embed code").toString()} className='mb-0' variant={`${copyCodeSuccess ? 'success' : 'info'}`} onClick={handleWidgetCopyCode}><i className={`material-symbols-outlined`} aria-hidden="true">{copyCodeSuccess ? 'done' : 'content_copy'}</i></Button>
                                    </div>
                                    <pre>{widgetCode}</pre>
                                </div>
            
            
                                {ReactAppAPIKeyChanges !== 'true' && (
                                    <>
                                        <div className="aioa_dashboard-widget-code-toggle-header">
                                            <div className="aioa_dashboard-widget-code-toggle">
                                                <Form.Check
                                                    type="checkbox"
                                                    id="code-switch"
                                                    label={`${t('Advance Code')}`}
                                                    checked={codeToggle}  // Ensure checkbox state is controlled
                                                    onChange={() => setCodeToggle(!codeToggle)}
                                                />
            
                                                <Button variant="outline-primary" onClick={() => handleShowWidgetAdvanceCodeInfoModel()} size="sm" aria-haspopup="true" aria-label={t("Information on Advanced Code")}>
                                                    <i className="material-symbols-outlined" aria-hidden="true">info</i>
                                                </Button>
            
                                                <Modal show={advanceCodeInfoModel} onHide={handleHideWidgetAdvanceCodeInfoModel} centered>
                                                    <Modal.Header closeButton>
                                                        <Modal.Title>{t('Advance Code')}</Modal.Title>
                                                    </Modal.Header>
                                                    <Modal.Body>{t('advance code info text')}</Modal.Body>
                                                </Modal>
                                            </div>
                                        </div>
            
                                        {/* Integration Script Based on Checked Value */}
                                        {codeToggle && (
                                            <script>
                                            </script>
                                        )}

                                        {isMigratedFlag && (
                                            <div className='mt-2'>
                                                {t('When you update your profile, we’ll automatically move your data to the EU server for you')}
                                            </div>
                                        )} 

                                    </>
                                )}
            
            
                            </Card.Body>
                        </Card>
                        {!isFirstTimeLoad && !isShowVerifyDomain && (
                            <>
                            <div className='fs-5 mt-4'>
                                <b>{t(`Would you like to proceed with the migration now`)}? &nbsp;</b>
                            </div>
                            </>
                        )}
                        {!isVerified && message && (
                            <div className="verify-domain_msg mt-3">{message}</div>
                        )}
                        {isVerified && (
                            <div className="verify-domain-success mt-3">✅ Domain Verified!</div>
                        )}
                    </>
                    }
                </Modal.Body>

                    <Modal.Footer className='justify-content-center'>
                    {!isMigrated ? 
                        <div>
                            <Button variant="primary" size="lg" onClick={() => handleMigration(true)}>
                                {t('yes btn label')}
                            </Button>
                            <Button variant="danger" size="lg" onClick={() => handleMigration(false)}>
                                {t('no btn label')}
                            </Button>
                            <Button variant="primary" size="lg" onClick={() => updateStoreForEUPopUp()}>
                                {t('May be later')}
                            </Button>
                        </div>
                    : 
                    <>
                    {!isFirstTimeLoad && !isShowVerifyDomain ? (
                        <>
                            {isMigratedFlag ? 
                                <Button variant="primary" size="lg" onClick={() => {
                                    handleClosePopup()
                                }}>
                                    {t('yes btn label')}
                                </Button>
                            : 
                            <Button variant="primary" size="lg" onClick={() => handleMigration(true)}>
                                    {t('yes btn label')}
                                </Button>
                            }
                            
                            {isMigratedFlag && revertBackToOriginalLanguage ? 
                            <Button variant="danger" size="lg" onClick={() => {
                                revertBackToOriginalLanguage()
                                handleClosePopup()
                            }}>
                                {t('no btn label')}
                            </Button>
                            : 
                            <Button variant="danger" size="lg" onClick={() => handleClosePopup()}>
                                {t('no btn label')}
                            </Button>
                            }
                        </>
                    ) : 
                        <>
                            <Button variant="primary" size="lg" onClick={() => verifyDomain()}>
                                {t('Verify domain')}
                            </Button>&nbsp;
                        </>
                    }
                    </>
                    }
                    </Modal.Footer>
            </Modal>
        </>
    )

}

export default EUServerMigrationPopup;